module.exports = __webpack_public_path__ + "img/sweden-tuberculosis-female.f6c60d5f.png";